import axios from "axios"

import { LINKS } from "@api/links.const"
import { handleError } from "@utils/error.middleware"

import { type APIError } from "@interfaces/APIError.interface"

interface APITypeSubscription {
  subscriptions: []
}

export interface APIToggleRenewalResponse {
  success: boolean
  id: number
}

export const APISubscription = {
  async getAllSubscriptions(): Promise<APITypeSubscription | APIError> {
    try {
      const response = await axios.post<APITypeSubscription>(LINKS.SUBSCRIPTION.GET_ALL())
      return response.data
    } catch (error) {
      return handleError(error)
    }
  },

  async toggleAutoRenewal(
    subscriptionId: number,
    isRecurrent: boolean
  ): Promise<APIToggleRenewalResponse | APIError> {
    try {
      const response = await axios.post<APIToggleRenewalResponse>(
        LINKS.SUBSCRIPTION.TOGGLE_AUTO_RENEWAL(),
        { subscriptionId, isRecurrent }
      )
      return response.data
    } catch (error) {
      return handleError(error)
    }
  }
}
